import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { axiosInstance } from "../../../@core/auth/jwt/jwtService";

export const getTicketAssignations = createAsyncThunk(
  "ticketAssignations/getTicketAssignations",
  async (args, thunkAPI) => {
    const {
      status,
      eventId,
      orderBy,
      pageSize,
      pageNumber,
      exhibitorId,
      searchQuery,
    } = args;
    try {
      const response = await axiosInstance.request({
        url: `/events/${eventId}/ticketAssignations`,
        method: "get",
        params: {
          status,
          orderBy,
          pageSize,
          pageNumber,
          searchQuery,
          exhibitorId,
        },
      });

      return { data: response };
    } catch (error) {
      return thunkAPI.rejectWithValue(
        "Error al consultar las invitaciones. Error: ",
        error
      );
    }
  }
);

export const getTicketAssignationsById = createAsyncThunk(
  "ticketAssignations/getTicketAssignationsById",
  async (args, thunkAPI) => {
    const { eventId, ticketAssignationsId } = args;
    try {
      const response = await axiosInstance.request({
        url: `/events/${eventId}/ticketAssignations/${ticketAssignationsId}`,
        method: "get",
      });
      return { data: response.data };
    } catch (error) {
      return thunkAPI.rejectWithValue(
        "Error al consultar los tickets. Error: ",
        error.response.status
      );
    }
  }
);

export const updateTicketAssignations = createAsyncThunk(
  "ticketAssignations/updateTicketAssignations",
  async (args, thunkAPI) => {
    const { id, eventId, data } = args;
    const response = await axiosInstance.request({
      url: `/events/${eventId}/ticketAssignations/${id}`,
      method: "patch",
      data,
    });
    return { data: response };
  }
);

export const ticketAssignationsSlice = createSlice({
  name: "ticketAssignations",
  initialState: {
    list: [],
    listById: {},
    totalRows: 0,
    pending: false,
    pendingById: false,
    pendingUpdate: false,
  },
  reducers: {
    clearListById: (state, action) => {
      state.listById = {};
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getTicketAssignations.fulfilled, (state, action) => {
        const { data } = action.payload;

        state.list = action.payload.data.data;
        state.pending = false;
        state.totalRows = JSON.parse(data?.headers["x-pagination"]).totalCount;
      })
      .addCase(getTicketAssignations.pending, (state, action) => {
        state.pending = true;
      })
      .addCase(getTicketAssignations.rejected, (state, action) => {
        state.pending = false;
      })
      .addCase(getTicketAssignationsById.fulfilled, (state, action) => {
        state.listById = action.payload.data;
        state.pendingById = false;
        state.pending = false;
      })
      .addCase(getTicketAssignationsById.pending, (state, action) => {
        state.pendingById = true;
        state.pending = true;
      })
      .addCase(getTicketAssignationsById.rejected, (state, action) => {
        state.pendingById = false;
        state.pending = false;
      })
      .addCase(updateTicketAssignations.fulfilled, (state, action) => {
        state.listById = action.payload.data;
        state.pendingUpdate = false;
      })
      .addCase(updateTicketAssignations.pending, (state, action) => {
        state.pendingUpdate = true;
      })
      .addCase(updateTicketAssignations.rejected, (state, action) => {
        state.pendingUpdate = false;
      });
  },
});

export const { clearListById } = ticketAssignationsSlice.reducer;

export default ticketAssignationsSlice.reducer;
